// extracted by mini-css-extract-plugin
export var boxItems = "_9r-1";
export var boxItemsLg = "_9r-2";
export var button = "_9r-7";
export var buttonHoverless = "_9r-9";
export var buttonLg = "_9r-8";
export var filterGroupBox = "_9r-0";
export var icon = "_9r-3";
export var iconSecondary = "_9r-6";
export var iconWrapper = "_9r-4";
export var iconWrapperLg = "_9r-5";
export var truncatedLabel = "_9r-a";